import i18n from "../../../../app/js/utils/i18n";

export const getData = () => {
    const kGrader = i18n.language == "en" ? "K" :  i18n.t("grader.K").substring(0, 1).toUpperCase() + i18n.t("grader.K").substring(1);
    const firstGrader =  i18n.t("grader.1st").substring(0, 1).toUpperCase() + i18n.t("grader.1st").substring(1);

    return [
        {
            title: `SplashLearn is great for ${i18n.t("practice")} and supplement traditional school or home lessons`,
            name: 'Abdelhalim',
            designation: `Parent, ${kGrader} & ${i18n.t("grader.5th")}`,
            image: 'https://cdn.splashmath.com/assets/casestudy/parents/abdelhalim-0f398c9393908f74f5e75c8d78f040dc8c2c32a7e750bca985686851067ab4d2.jpg',
            isCdnImage: true
        },
        {
            title: `Can't tell you enough how wonderful SplashLearn is`,
            name: 'Robyn Meeker',
            designation: `Parent, ${firstGrader}`,
            image: 'https://cdn.splashmath.com/assets/casestudy/parents/robyn1-9f60fe6902fd770315bf55c55150e66b219fadeb18b6cf4d61e44ebb8877e751.jpg',
            isCdnImage: true
        },
        {
            title: `Learning ${i18n.t("Math")} is so much easier with SplashLearn`,
            name: 'Glenndel Prochnow',
            designation: `Parent, ${kGrader}`,
            image: 'https://cdn.splashmath.com/assets/casestudy/parents/glenndel.png',
            isCdnImage: true
        }
    ]
}